/**
 * Nsection B14 Service
 * B.14.事前參數說明 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b14';

export interface ParameterItem {
  id: string;
  data_parameter: string;
  description: string;
  data_unit: string;
  equations_referred: string;
  purpose_baseline: boolean;
  purpose_project: boolean;
  purpose_leakage: boolean;
  values_applied: string;
  source: string | null;
  measurement_methods: string;
  treatment_of_uncertainty: string;
  additional_comments: string;
  b13_ref: {
    source_section: string;
    source_label: string;
    symbol: string;
    para_type: number | null;
    equation_latex: string;
  } | null;
}

export interface NsectionB14Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  parameters: ParameterItem[] | null;
  nsection_b14_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB14Update {
  parameters?: ParameterItem[];
}

const nsectionB14Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB14Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB14Update): Promise<NsectionB14Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB14Service;
